import React, { ReactElement } from 'react';
import { Container, Icon, EmptyState, H3, styled } from '@erecruit/ui-kit';

interface EmptyStateContainer {
  className?: string;
  text: string | ReactElement;
}

const EmptyStateContainer = styled(
  ({ className, text }: EmptyStateContainer) => (
    <Container
      className={className}
      padding={12}
      gutter={4}
      gutterDirection="vertical"
      stretch
    >
      <EmptyState
        description={<H3 align="center">{text}</H3>}
        image={<Icon type="empty-state" size="large" />}
      />
    </Container>
  ),
)(() => ({
  marginTop: '10vh',
  backgroundColor: 'inherit',
}));

export default EmptyStateContainer;
